import { render } from "./ReserveInfoList_admin.vue?vue&type=template&id=27abed05&scoped=true"
import script from "./ReserveInfoList_admin.vue?vue&type=script&lang=js"
export * from "./ReserveInfoList_admin.vue?vue&type=script&lang=js"

import "./ReserveInfoList_admin.vue?vue&type=style&index=0&id=27abed05&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27abed05"]])

export default __exports__